import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Form from 'deltoid/core/Form';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Body, Small } from 'deltoid/core/Blocks/Typography';
import VerifyOTP from '@components/BaseComponents/VerifyOTP';


import {
  dialogActions,
  dialogSelectors,
  kycActions,
  kycActionTypes,
  kycSelectors,
} from '@store/ducks';

const VerifyAadharOTP = ({
  goBack: goBackProp,
  closeDialog,
  aadharVerifyOtp,
  errMsgAadharVerifyOtp,
  aadharVerifyOtpProcessing,
  errMsgAadharGetOtp,
  resendOTP,
  getDialogProps,
}) => {
  const [err, setError] = useState(null);
  const [retryTime, setRetryTime] = useState(60*1000);
  const [disableResend, setDisableResend] = useState(true);

  useEffect(()=> {
    if (errMsgAadharVerifyOtp) setError(new String(errMsgAadharVerifyOtp));
  }, [errMsgAadharVerifyOtp]);
  useEffect(()=> {
    if (errMsgAadharGetOtp) setError(new String(errMsgAadharGetOtp));
  }, [errMsgAadharGetOtp]);
  useEffect(()=> {}, [getDialogProps]);

  const goBack = () => {
    closeDialog(kycActionTypes.resetAadharState);
    goBackProp();
  }

  const onSubmit = (otp) => {
    if (otp && otp.length === 6) {
      aadharVerifyOtp(otp);
    } else {
      setError('Enter complete otp');
    }
  }
  const { aadhar_number, message, attempts_remaining } = getDialogProps || {};
  return (
    <VerifyOTP
      heading='Fetch your KYC details using your Aadhar number'
      title='Enter 6-digit OTP'
      subTitle={message ? message : 'OTP is sent to the mobile linked to the Aadhar number you entered'}
      handleVerifyOTP={onSubmit}
      goBack={goBack}
      errMsg={err}
      resendOtp={attempts_remaining && attempts_remaining != 0 ? () => {
        setRetryTime(60*1000);
        setDisableResend(true);
        resendOTP(aadhar_number);
      } : false}
      retryTime={retryTime}
      onTimerComplete={() => {setRetryTime(false); setDisableResend(false);}}
      disableResend={disableResend}
      hint={`
        Note: Make sure this Aadhar number is linked to your registered mobile number. 
        An OTP will be sent to registered number.
      `}
      otpLength={6}
      disableVerifyBtn={aadharVerifyOtpProcessing}
      loadingVerifyBtn={aadharVerifyOtpProcessing}
      label='aadhar-verify-otp-'
    />
  )
};

const mapStateToProps = (state) => ({
  errMsgAadharVerifyOtp: kycSelectors.errMsgAadharVerifyOtp(state),
  errMsgAadharGetOtp: kycSelectors.errMsgAadharGetOtp(state),
  aadharVerifyOtpProcessing: kycSelectors.aadharVerifyOtpProcessing(state),
  getDialogProps: dialogSelectors.getProps(state),
})

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  goBack: () => dispatch(dialogActions.open('aadhar-get-otp')),
  openAddress: () => dispatch(dialogActions.open('kyc-address')),
  aadharVerifyOtp: (otp) => dispatch(kycActions.aadharVerifyOtp(otp)),
  resendOTP: (aadharNumber) => dispatch(kycActions.aadharGetOtp(aadharNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAadharOTP);
